{
  "title": "Récapitulatif des activités",
  "recapAsOf": "En date du",
  "viewActivity": "Voir le journal complet →",
  "empty": "Aucune activité de lot au cours des 2 derniers jours ouvrables",
  "filterNoResults": "Aucun événement ne correspond à ce filtre",
  "errorPrefix": "Erreur :",
  "cards": {
    "batchesRun": {
      "title": "LOTS EXÉCUTÉS"
    },
    "tradesSent": {
      "title": "TRANSACTIONS ENVOYÉES"
    },
    "portfoliosRebalanced": {
      "title": "PORTEFEUILLES RÉÉQUILIBRÉS"
    },
    "failedOrCanceled": {
      "title": "ÉCHOUÉS / ANNULÉS"
    }
  },
  "eventLog": {
    "sectionTitle": "JOURNAL DES ÉVÉNEMENTS",
    "columns": {
      "type": "Type",
      "description": "Description",
      "metrics": "Mesures",
      "status": "Statut",
      "time": "Heure"
    }
  },
  "filters": {
    "all": "Tous",
    "completed": "Terminés",
    "tradesSent": "Transactions envoyées",
    "failedOrCanceled": "Échoués / annulés"
  },
  "status": {
    "COMPLETED": "Terminé",
    "SENT": "Envoyé",
    "FAILED": "Échoué",
    "CANCELED": "Annulé"
  },
  "asOfLast48Hours": "Dernières 48 heures",
  "summary": {
    "batchesRunDescription": "Sur 2 jours ouvrables",
    "tradesSentDescription": "Soumis aux dépositaires",
    "portfoliosRebalancedDescription": "Chez tous les dépositaires",
    "failedOrCanceledDescription": "Nécessitent un examen"
  },
  "events": {
    "portfoliosOptimized_one": "{{count}} portefeuille optimisé",
    "portfoliosOptimized_other": "{{count}} portefeuilles optimisés",
    "bulkTradeRunState": "Exécution de transactions en bloc {{state}}"
  },
  "metrics": {
    "trades_one": "transaction",
    "trades_other": "transactions",
    "portfolios_one": "portefeuille",
    "portfolios_other": "portefeuilles"
  }
}
